module.exports = __webpack_public_path__ + "static/media/cross-icon.dfd9df60.svg";